/**
 * The space to simulate particles in.
 */
export enum ParticleSimulationSpace {
  /** Simulate particles in local space. */
  Local,
  /** Simulate particles in world space. */
  World
}
